import { inject, Injectable } from '@angular/core'
import { createObject, pickPropsAssertDefined } from '@pai/commons'
import { firstValueFrom } from 'rxjs'

import { CmsService } from '../cms/cms.service'
import { JsonLd } from '../json-ld.service'
import { ORIGIN } from '../origin/origin.token'

@Injectable({ providedIn: 'root' })
export class JsonLdLoaderService {
  get organization(): JsonLd {
    if (!this._organization) {
      throw new Error('organization JsonLD not yet loaded')
    }
    return this._organization
  }

  private readonly origin = inject(ORIGIN)
  private readonly cms = inject(CmsService)
  private _organization: JsonLd

  readonly load = async (): Promise<void> => {
    this._organization = await firstValueFrom(this.cms.organisation).then((jsonLdData) =>
      createObject('Organization', {
        '@id': this.origin,
        url: this.origin,
        ...pickPropsAssertDefined(jsonLdData, 'email', 'legalName', 'name', 'vatID', 'logo'),
        address: {
          '@type': 'PostalAddress',
          ...pickPropsAssertDefined(
            jsonLdData,
            'streetAddress',
            'postalCode',
            'addressLocality',
            'addressRegion',
            'addressCountry',
          ),
        },
        contactPoint: [{ '@type': 'ContactPoint', contactType: 'sales', email: jsonLdData.email }],

        sameAs: jsonLdData.sameAs.split(/[,\n]{1,2}/).filter((i) => i.startsWith('https://')),
      }),
    )
  }
}
